import axios from 'axios';

const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

function reviver(key, value) {
    if (typeof value === "string" && dateFormat.test(value)) {
        // console.log("transforming: " + value);
        return new Date(value);
    }
    return value;
}

const apiClient = {
    get: function (url) {
        return axios.get(url)
            .then(response => {
                return JSON.parse(JSON.stringify(response.data), reviver);
            });
    }
};

export default apiClient;



// WEBPACK FOOTER //
// ./src/apis/apiClient.js